import styled from 'styled-components';

export const UnlockTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #323232;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 16px;
`;

export const UnlockWrapper = styled.div`
  background: linear-gradient(92.01deg, #00BFA5 0%, #007F90 100%);
  max-width: 330px;
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 24px;
  border-radius: 16px;
`;

export const OfferTitle = styled.div`
  letter-spacing: -0.46;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 30px;
  line-height: 30px;
  color: #FFFFFF;
  margin-bottom: 8px;
`;

export const OfferDescription = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #A7E2DA;
`;